function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.8,13.6 C14.604,13.863 14.304,14 13.999,14 C13.79,14 13.58,13.935 13.401,13.8 L9.401,10.8 C9.149,10.612 9,10.315 9,10 L9,6 C9,5.448 9.447,5 10,5 C10.553,5 11,5.448 11,6 L11,9 C11,9.315 11.149,9.612 11.401,9.8 L14.6,12.201 C15.042,12.532 15.132,13.159 14.8,13.6 M10,0 C4.486,0 0,4.486 0,10 C0,15.514 4.486,20 10,20 C15.514,20 20,15.514 20,10 C20,4.486 15.514,0 10,0",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/clock.a6cf833a.svg";
export { SvgComponent as ReactComponent };